import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "page-filters pf-bar"
}
const _hoisted_3 = { class: "next-nodes-grid" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "next-node-card-top" }
const _hoisted_6 = { class: "next-node-card-name" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_forge_page_button = _resolveComponent("forge-page-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_add_edit_skills_matrix = _resolveComponent("add-edit-skills-matrix")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Team"),
        _createElementVNode("div", { class: "page-bar-main" }, "Skills Matrix")
      ])
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      (_ctx.$store.state.user.teamHubRole == 'Admin')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_forge_page_button, {
              kinds: ['skills'],
              label: "Build with AI",
              onApplied: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getMatrices()))
            }),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = () => { _ctx.showAddMatrix = true }),
              class: "add-btn"
            }, "Add")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matrices, (matrix, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "next-node-card-wrap"
            }, [
              _createElementVNode("div", {
                class: "next-node-card",
                onClick: () => { _ctx.$router.push('/skills-matrix/'+matrix.ID) }
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(matrix.Name), 1),
                  (_ctx.$store.state.user.teamHubRole == 'Admin')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "next-node-menu-btn",
                        onClick: _withModifiers(($event: any) => (_ctx.toggleMatrixMenu(matrix, $event)), ["stop"])
                      }, [
                        _createVNode(_component_svg_icon, { icon: "dots" })
                      ], 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_4),
              (_ctx.openMatrixId == matrix.ID)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "next-node-menu-dropdown",
                    style: _normalizeStyle(_ctx.matrixMenuStyle),
                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createVNode(_component_router_link, {
                      to: '/skills-matrix/'+matrix.ID+'?edit=t',
                      onClick: _ctx.closeMatrixMenu
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("Edit", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to", "onClick"]),
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (_ctx.matrixMenuAction(() => _ctx.deleteMatrix(matrix))), ["prevent"])
                    }, "Delete", 8, _hoisted_8)
                  ], 4))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ], 2),
    (_ctx.showAddMatrix)
      ? (_openBlock(), _createBlock(_component_add_edit_skills_matrix, {
          key: 0,
          onClose: _cache[3] || (_cache[3] = () => { _ctx.showAddMatrix = false; _ctx.getMatrices() })
        }))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 1,
          onConfirm: _ctx.deleteConfirm,
          onCancel: _cache[4] || (_cache[4] = () => { _ctx.showConfirmDelete = false; }),
          msg: "Are you sure you would like to delete this skills matrix?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true)
  ]))
}